/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensor_SalinityInputs */

const vi_irrigation_sensor_salinity = /** @type {(inputs: Irrigation_Sensor_SalinityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Độ mặn`)
};

/**

* @param {Irrigation_Sensor_SalinityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensor_salinity = /** @type {((inputs?: Irrigation_Sensor_SalinityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensor_SalinityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensor_salinity(inputs)
});